
export type MessagingCreateChatRoomBodyRoomInfoType = typeof MessagingCreateChatRoomBodyRoomInfoType[keyof typeof MessagingCreateChatRoomBodyRoomInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingCreateChatRoomBodyRoomInfoType = {
  DIRECT: 'DIRECT',
  GROUP: 'GROUP',
} as const;
